import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './app.routes'
import { provideTranslateService } from '@ngx-translate/core'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import {
  authInterceptor,
  errorInterceptor
} from './interceptors/http.interceptor'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideTranslateService(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]))
  ]
}
